"use client";

import { TileBadge } from "@faire/retailer-visitor-shared/components/InsiderBadge/__internal__/TileBadge";
import { useInsiderFeatureEligibility } from "@faire/retailer-visitor-shared/hooks/insider/useInsiderFeatureEligibility";
import { useInsiderState } from "@faire/retailer-visitor-shared/hooks/insider/useInsiderState";
import { IApplicableMembershipBenefits } from "@faire/web-api--source/indigofair/data/IApplicableMembershipBenefits";
import React from "react";

export interface IInsiderTileBadgeRendererProps {
  className?: string;
  insiderBenefits?: IApplicableMembershipBenefits;
  insiderLabelText?: string;
}

// TODO (RSC Product Tile): Remove "use client" after this component is migrated to RSC
export const InsiderTileBadgeRenderer: React.FC<
  IInsiderTileBadgeRendererProps
> = (props) => {
  const { isInsider: isCurrentRetailerInsider, isInsiderActive } =
    useInsiderState();

  const hasInsiderBenefitsForBrand = !!props.insiderBenefits?.benefits?.length;
  const shouldShowBadging = isCurrentRetailerInsider;

  if (props.insiderLabelText === undefined) {
    return null;
  }

  if (shouldShowBadging && hasInsiderBenefitsForBrand) {
    return (
      <InsiderTileBadgeRendererContent
        {...{
          isInsiderActive,
          ...props,
        }}
      />
    );
  }

  return null;
};

interface IInsiderTileBadgeRendererContentProps {
  className?: string;
  insiderBenefits?: IApplicableMembershipBenefits;
  insiderLabelText?: string;
  isInsiderActive?: boolean;
}
const InsiderTileBadgeRendererContent: React.FC<
  IInsiderTileBadgeRendererContentProps
> = ({ className, insiderBenefits, insiderLabelText, isInsiderActive }) => {
  const { hasFreeDutyAdvertising } = useInsiderFeatureEligibility();
  let hasFreeDuties: boolean = false;

  if (isInsiderActive || hasFreeDutyAdvertising) {
    hasFreeDuties = !!insiderBenefits?.benefits.includes(
      IApplicableMembershipBenefits.ApplicableMembershipBenefitType
        .INSIDER_FREE_DUTIES
    );
  }

  const hasFreeShipping = !!insiderBenefits?.benefits.includes(
    IApplicableMembershipBenefits.ApplicableMembershipBenefitType
      .INSIDER_FREE_SHIPPING
  );

  return (
    <TileBadge
      className={className}
      hasFreeDuties={hasFreeDuties}
      hasFreeShipping={hasFreeShipping}
      insiderBadgeText={insiderLabelText}
    />
  );
};
